import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    if (!sid) { nav('/login', { replace: true }); return; }

    (async () => {
      try {
        const { data } = await api.post('/auth/session', { session_id: sid });
        setUser(data.user);
        // clean URL
        window.history.replaceState({}, '', '/profiles');
        nav('/profiles', { replace: true, state: { user: data.user } });
      } catch (e) {
        nav('/login', { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-14 h-14 rounded-full border-4 border-white/10 border-t-[#E50914] animate-spin" />
        <div className="text-white/70">Signing you in…</div>
      </div>
    </div>
  );
};

export default AuthCallback;
